var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1562 3.93388L23.7604 7.75659V13.5337C23.7604 19.0895 20.0975 24.2151 15.1562 25.7393C10.215 24.2151 6.55208 19.0895 6.55208 13.5337V7.75659L15.1562 3.93388ZM15.1562 1.242L4.09375 6.15867V13.5337C4.09375 20.3555 8.81375 26.7349 15.1562 28.2837C21.4987 26.7349 26.2188 20.3555 26.2188 13.5337V6.15867L15.1562 1.242ZM13.9271 8.617H16.3854V11.0753H13.9271V8.617ZM13.9271 13.5337H16.3854V20.9087H13.9271V13.5337Z",
    fill: "#3D64E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingPrivacy);
export default __webpack_public_path__ + "static/media/setting_privacy.2a4512e752087cddee6f974759e9113b.svg";
export { ForwardRef as ReactComponent };